import { type RefObject, useLayoutEffect } from "react";

/**
 * Keeps a CSS custom property on `<html>` equal to an element's height in px
 * (12 Oct). The app header sets `--app-header-height` with it, so anything
 * sticky below the header (`top-[var(--app-header-height)]`) sits under it
 * whatever the header holds: the UAT environment banner, "View as", the
 * kiosk strip, a wrapped line on a phone. Removed again on unmount.
 */
export function useHeightVariable(ref: RefObject<HTMLElement | null>, name: string): void {
  useLayoutEffect(() => {
    const element = ref.current;
    if (element === null) {
      return;
    }
    const root = document.documentElement;
    const write = () => root.style.setProperty(name, `${element.getBoundingClientRect().height}px`);
    write();
    if (typeof ResizeObserver === "undefined") {
      return () => root.style.removeProperty(name);
    }
    const observer = new ResizeObserver(write);
    observer.observe(element);
    return () => {
      observer.disconnect();
      root.style.removeProperty(name);
    };
  }, [ref, name]);
}
